import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Practice } from "@/components/Practice";
import { Voices } from "@/components/Voices";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -64, duration: 1.4 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="App min-h-screen bg-cream text-olive font-sans antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <About />
        <Practice />
        <Voices />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
